import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b5bace06"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["width", "height"]
const _hoisted_2 = ["rx", "ry", "width", "height", "stroke", "stroke-width", "stroke-dasharray"]

import { PropType, toRef } from 'vue'
import { PPTElementOutline } from '@/types/slides'
import useElementOutline from '@/views/components/element/hooks/useElementOutline'


export default /*#__PURE__*/_defineComponent({
  __name: 'ImageRectOutline',
  props: {
  width: {
    type: Number,
    required: true,
  },
  height: {
    type: Number,
    required: true,
  },
  outline: {
    type: Object as PropType<PPTElementOutline>
  },
  radius: {
    type: String,
    default: '0',
  },
},
  setup(__props) {

const props = __props



const {
  outlineWidth,
  outlineStyle,
  outlineColor,
} = useElementOutline(toRef(props, 'outline'))

return (_ctx: any,_cache: any) => {
  return (__props.outline)
    ? (_openBlock(), _createElementBlock("svg", {
        key: 0,
        class: "image-rect-outline",
        overflow: "visible",
        width: __props.width,
        height: __props.height
      }, [
        _createElementVNode("rect", {
          "vector-effect": "non-scaling-stroke",
          "stroke-linecap": "butt",
          "stroke-miterlimit": "8",
          fill: "transparent",
          rx: __props.radius,
          ry: __props.radius,
          width: __props.width,
          height: __props.height,
          stroke: _unref(outlineColor),
          "stroke-width": _unref(outlineWidth),
          "stroke-dasharray": _unref(outlineStyle) === 'dashed' ? '10 6' : '0 0'
        }, null, 8, _hoisted_2)
      ], 8, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})